(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    

	$('.main-cart .quantity button').click(function() {

		var plus = $(this).hasClass('plus');
		var minus = $(this).hasClass('minus');
		var index = $(this).attr('data');
		var quantity = parseInt($('.qty_' + index).val());

		if(plus == true) {
			quantity += 1;
		} else if(minus == true) {
			if(quantity > 0) {
				quantity -= 1;
			}
		}
		$('.qty_' + index).val(quantity);
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-faq"] && !Shopify.designMode) return;
  try {
    

  $('button.question').click(function() {
    var handle = $(this).attr('data');
    $('.answer-'+handle).slideToggle(150);
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme_footer"]) return;
  try {
    

  // subnavigation
  $('footer nav button').click(function() {

    // display child menu
    var handle = $(this).attr('data');
    $('footer .ul-' + handle).slideToggle(150);

    // animate button "plus" icon
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();
})();
